<template>
  <div class="search-form-box">
    <el-form
      ref="searchFormRef"
      inline
      :model="searchForm"
      size="small"
      :label-width="labelWidth"
      @submit.native.prevent
    >
      <el-row class="row" justify="start">
        <el-col
          :span="cond.span || 6"
          v-for="cond in sliceCodList"
          :key="cond.prop"
          v-show="cond.show !== false"
        >
          <el-form-item
            :label="cond.label + '：'"
            :prop="cond.prop"
            class="flex-form-item"
          >
            <!-- 输入框 -->
            <el-input
              v-if="cond.type === 'input'"
              class="item-width"
              v-model="searchForm[cond.prop]"
              :disabled="cond.disabled || false"
              :placeholder="cond.placeholder"
              :clearable="cond.clearable === undefined ? true : cond.clearable"
              @keyup.enter.native="search"
              @change="(val) => handleFormChange(cond.prop, val)"
            />
            <!-- 下拉框 -->
            <el-select
              v-else-if="cond.type === 'select'"
              class="item-width"
              v-model="searchForm[cond.prop]"
              :disabled="cond.disabled || false"
              :placeholder="cond.placeholder"
              :multiple="cond.multiple || false"
              filterable
              :clearable="cond.clearable === undefined ? true : cond.clearable"
              @change="(val) => handleFormChange(cond.prop, val)"
            >
              <el-option
                v-for="op in cond.options || []"
                :key="op.value"
                :label="op.label"
                :value="op.value"
              />
            </el-select>
            <!-- 树型选择框 -->
            <!-- <treeselect
              v-else-if="cond.type === 'treeSelect'"
              class="item-width"
              v-model="searchForm[cond.prop]"
              :disabled="cond.disabled || false"
              :options="cond.options || []"
              :show-count="true"
              :placeholder="cond.placeholder"
              @input="(val) => handleFormChange(cond.prop, val)"
            /> -->
            <!-- 日期组合 -->
            <el-date-picker
              v-else-if="cond.type === 'date'"
              class="item-width"
              v-model="searchForm[cond.prop]"
              :disabled="cond.disabled || false"
              :type="cond.dateType || 'daterange'"
              :value-format="cond.valueFormat || 'yyyy-MM-dd'"
              :placeholder="cond.placeholder || '请选择日期'"
              :start-placeholder="cond.startPlaceholder || '请选择开始日期'"
              :end-placeholder="cond.endPlaceholder || '请选择结束日期'"
              :picker-options="cond.pickerOptions || {}"
              @change="(val) => handleFormChange(cond.prop, val)"
            />
            <!-- 单选框 -->
            <el-radio-group
              v-else-if="cond.type === 'radio'"
              class="item-width"
              v-model="searchForm[cond.prop]"
              :disabled="cond.disabled || false"
              @input="(val) => handleFormChange(cond.prop, val)"
            >
              <el-radio
                v-for="op in cond.options"
                :key="op.value"
                :label="op.value"
                >{{ op.label }}</el-radio
              >
            </el-radio-group>
            <!-- 复选框 -->
            <el-checkbox-group
              v-else-if="cond.type === 'checkbox'"
              class="item-width"
              v-model="searchForm[cond.prop]"
              :disabled="cond.disabled || false"
              @input="(val) => handleFormChange(cond.prop, val)"
            >
              <el-checkbox
                v-for="op in cond.options"
                :key="op.value"
                :label="op.value"
                >{{ op.label }}</el-checkbox
              >
            </el-checkbox-group>
            <slot :name="cond.prop" v-if="cond.type == 'slot'"></slot>
          </el-form-item>
        </el-col>
        <el-col :span="rSpanCount" class="el-col-wrapper">
          <el-form-item
            class="btn-group-item"
            :class="{ 'flex-end': showFoldBtn }"
          >
            <el-button type="primary" icon="el-icon-search" @click="search"
              >查询</el-button
            >
            <el-button
              v-if="showResetBtn"
              plain
              icon="el-icon-refresh"
              @click="reset"
              >重置</el-button
            >
            <el-button v-show="showFoldBtn" type="text" @click="toggleFold">
              <i v-if="conditionFold" class="el-icon-arrow-down"></i>
              <i v-else class="el-icon-arrow-up"></i>
              {{ conditionFold ? "展开" : "收起" }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
// import Treeselect from "@riophae/vue-treeselect";
// import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "SearchBar",
  // components: { Treeselect },
  props: {
    searchConfig: {
      type: Array,
      default: () => [],
    },
    searchForm: {
      type: Object,
      default: () => {},
    },
    showResetBtn: {
      type: Boolean,
      default: true,
    },
    labelWidth: {
      type: String,
      default: "120px",
    },
  },
  data() {
    return {
      conditionFold: false,
      initConditionFoldLen: 3, // 每一行减去按钮项最多显示几项
    };
  },
  computed: {
    // 处于显示状态的筛选项
    showSearchConfig() {
      return this.searchConfig.filter((item) => item.show !== false);
    },
    // 是否展示展开收起按钮
    showFoldBtn() {
      return this.showSearchConfig.length > this.initConditionFoldLen;
    },
    // 操作按钮区域占据宽度
    rSpanCount() {
      let totalSpan = 0;
      if (!this.conditionFold) {
        totalSpan = this.showSearchConfig.reduce((prev, next) => {
          return prev + (next.span || 6);
        }, 0);
      } else {
        const sliceCondList = this.showSearchConfig.slice(
          0,
          this.initConditionFoldLen
        );
        totalSpan = sliceCondList.reduce((prev, next) => {
          return prev + (next.span || 6);
        }, 0);
      }
      return 24 - (totalSpan % 24);
    },
    // 当前需要渲染的筛选项数据
    sliceCodList() {
      return this.showSearchConfig.slice(
        0,
        this.conditionFold
          ? this.initConditionFoldLen
          : this.showSearchConfig.length
      );
    },
  },
  methods: {
    toggleFold() {
      this.conditionFold = !this.conditionFold;
    },
    search() {
      this.$emit("search", this.searchForm);
    },
    reset() {
      this.$refs.searchFormRef.resetFields();
      this.$emit("reset");
    },
    handleFormChange(prop, val) {
      this.$emit("formChange", prop, val);
    },
  },
};
</script>

<style lang="less" scoped>
.search-form-box {
  box-sizing: border-box;
  box-shadow: var(--el-box-shadow-light);
  background-color: #fff;
  border-radius: 4px;
  .row {
    display: flex;
    flex-wrap: wrap;
  }

  .flex-form-item {
    display: flex;
    align-items: center;
    ::v-deep .el-form-item__content {
      flex: 1;
      .item-width {
        width: 100%;
      }
      .vue-treeselect {
        .vue-treeselect__control {
          height: 34px;
        }
      }
    }
  }

  .el-col-wrapper {
    display: flex;
    .btn-group-item {
      flex: 1;
      display: flex;
      ::v-deep .el-form-item__content {
        flex: 1;
        display: flex;
        align-items: center;
      }
      &.flex-end {
        ::v-deep .el-form-item__content {
          justify-content: flex-end;
        }
      }
    }
  }
}
</style>